import { useAccount } from "@qw/auth";
import { type BankanQuoteColumn, useBankanQuoteColumnQuery } from "@qw/graphql";
import { groupBy } from "lodash";
import { weekWindow } from "@/helpers";
import { BankanCardQuotes } from "./bankan-card-quotes";
import { BankanGrid } from "./bankan-grid";

export const BankanQuotes = ({ column }: { column: BankanQuoteColumn }) => {
  const { user } = useAccount();

  const { data } = useBankanQuoteColumnQuery({
    variables: {
      input: {
        brokerId: user.id,
        column,
      },
    },
    fetchPolicy: "cache-and-network",
  });

  const now = Date.now();
  const insured = data?.bankanQuoteColumn?.groupedQuotes || [];

  if (insured.length === 0) {
    return null;
  }

  const groups = groupBy(insured, ({ quotes: { 0: first } }) =>
    weekWindow(new Date(first.effectiveDate).getTime() - now)
  );

  return (
    <>
      {Object.keys(groups).map((group) => (
        <BankanGrid key={group} count={groups[group].length} label={group}>
          {groups[group].map(({ insured, quotes }) => (
            <BankanCardQuotes key={insured.id} insured={insured} quotes={quotes} />
          ))}
        </BankanGrid>
      ))}
    </>
  );
};
